export enum Phases {
    L1 = 'L1',
    L2 = 'L2',
    L3 = 'L3',
    L123 = 'L123',
    L1L2 = 'L1L2',
    L2L3 = 'L2L3',
    L3L1 = 'L3L1',
    L1L2L3 = 'L1,L2,L3',
}

export enum PhaseMode {
    onePhase = '1P',
    twoPhase = '2P',
    threePhase = '3P',
}

export const PHASES_LIST_TN = ['L1', 'L2', 'L3', 'L123']
export const PHASES_LIST_IT = ['L1L2', 'L2L3', 'L3L1']
export const LUNA_PHASES_LIST = ['L1', 'L123']
export const LUNA_PHASES_LIST_IT = ['L1L2']
